var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.layout.Data
    ? _c("app-label-layout-editor", {
        attrs: { layout: _vm.layout.Data.Data, name: _vm.layout.Name },
        on: {
          "update:name": function ($event) {
            return _vm.$set(_vm.layout, "Name", $event)
          },
          save: function ($event) {
            return _vm.save()
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }